import BaseNameSideItem from '@Enum/BaseNameSideMenuItem.enum';
import { PageTypes } from '@Enum/PageTypes.enum';

const pageTypePerMenuItem: Record<string, string> = {
  [PageTypes.RESPOND_TASK]: BaseNameSideItem.APPROVALS,
  [PageTypes.APPROVALS]: BaseNameSideItem.APPROVALS,
  [PageTypes.MY_REQUESTS]: BaseNameSideItem.MY_REQUESTS,
  [PageTypes.CREATE_MY_REQUEST]: BaseNameSideItem.MY_REQUESTS,
  [PageTypes.EDIT_MY_REQUEST]: BaseNameSideItem.MY_REQUESTS,
  [PageTypes.DASHBOARD]: BaseNameSideItem.DASHBOARD,
  [PageTypes.PROCUREMENT]: BaseNameSideItem.PROCUREMENT,
  [PageTypes.CREATE_PROCUREMENT]: BaseNameSideItem.PROCUREMENT,
  [PageTypes.EDIT_PROCUREMENT]: BaseNameSideItem.PROCUREMENT,
  // '???': BaseNameSideItem.REPORTS, // todo update key in future
};

export const getSelectedMenuItem = (
  pageType: string | undefined
): string[] | undefined => {
  if (!pageType) {
    return undefined;
  }

  const menuItem = pageTypePerMenuItem[pageType];

  if (!menuItem) {
    return undefined;
  }

  return [menuItem];
};
